function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", null, ".dot_menu_svg__st0{fill:#b2b2b2}");
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "dot_menu_svg__st0",
  cx: 256,
  cy: 256,
  r: 64
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "dot_menu_svg__st0",
  cx: 256,
  cy: 448,
  r: 64
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "dot_menu_svg__st0",
  cx: 256,
  cy: 64,
  r: 64
});
function SvgDotMenu(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dot_menu_svg__Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "666a637dbb90c7a17872dfef036cd5e7.svg";
export { SvgDotMenu as ReactComponent };